﻿// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import NewsItem from './components/NewsItem.vue';
import NewsSkeleton from './components/NewsSkeleton.vue';

const newsApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        NewsItem,
        NewsSkeleton
    }
};

export default newsApp;
